<template>
  <section class="py-12">
    <div class="container-wrap">
      <p class="text-sm font-bold text-gray-600">
        {{ tGlobal('products.section-name.cases') }}
      </p>
      <h2 class="text-h2 mb-6">{{ t('title') }}</h2>

      <CarouselProgressbar :carousel-list="productCases" :slides-per-view="1">
        <template #card="{ item }">
          <CasesCard :item-data="item" />
        </template>
      </CarouselProgressbar>
    </div>
  </section>
</template>

<script setup lang="ts">
  import CasesCard from '@/components/Area/Products/CasesCard.vue';

  const { t } = useI18n({ useScope: 'local' });
  const { t: tGlobal } = useI18n({ useScope: 'global' });

  const productsStore = useProductsStore();
  const { productCases } = storeToRefs(productsStore);
</script>

<i18n lang="json">
{
  "en-int": {
    "title": "Explore Success Stories"
  },
  "en-jp": {
    "title": "Explore Success Stories"
  },
  "en-tw": {
    "title": "Explore Success Stories"
  },
  "en-kr": {
    "title": "Explore Success Stories"
  },
  "en-americas": {
    "title": "Explore Success Stories"
  },
  "en-asia-pacific": {
    "title": "Explore Success Stories"
  },
  "en-emea": {
    "title": "Explore Success Stories"
  },
  "ja-jp": {
    "title": "導入事例を見る"
  },
  "zh-cn": {
    "title": "见证客户成功案例"
  },
  "zh-tw": {
    "title": "見證客戶成功案例"
  }
}
</i18n>
